<template>
    <span>
        <a class="navbar-brand" :href="homeUrl">{{hostName}}</a>
        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#myNavbar"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    </span>
</template>

<script>
import { context, NO_URL } from "../../context";
const HTW_DOMAIN = ".htwsaar.de";

function parseURL(url) {
  const urlInfos = {
    protocol: NO_URL,
    hostname: NO_URL,
    port: NO_URL,
    pathname: ""
  };
  if (url !== NO_URL) {
    const a = document.createElement("a");
    a.href = url;
    urlInfos.protocol = a.protocol;
    urlInfos.hostname = a.hostname;
    urlInfos.port = a.port;
  }
  return urlInfos;
}

export default {
  name: "nav-header",
  data() {
    return {
      homeUrl: context.baseUrl,
      hostName: parseURL(context.baseUrl).hostname.replace(HTW_DOMAIN, "")
    };
  }
};
</script>

<style scoped="">
.navbar-brand {
  color: #0074d9;
  font-weight: initial;
}
.navbar-brand:hover {
  color: #000088;
}
</style>
